import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import truncateString from '../../../services/data/truncateString'
import media from '../../../services/generateMediaQueries'

const StyledLink = styled(Link)`
  text-decoration: none;
  ${props => (props.isDisabled ? 'pointer-events: none;' : '')}
`

const CardWrapper = styled.div`
  outline: none;
  margin-bottom: 1rem;
`

const CardImageBanner = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.url}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  transition: all 0.5s;

  ${media.lessThan('small')`
    display: none
  `}
`

const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100px;
  background: #ffffff;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-large);
  overflow: hidden;

  ${media.lessThan('small')`
    height: 80px;
  `}

  &:hover {
    ${CardImageBanner} {
      transform: scale(1.2);
    }
  }
`

const CardImageLogo = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.url}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
}))`
  position: absolute;
  display: none;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  transition: all 0.5s;

  ${media.lessThan('small')`
    display: block;
  `}
`

const CardImageWrapper = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 200px;
  height: 100%;
  overflow: hidden;

  ${media.lessThan('small')`
    width: 89px;
  `}
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  justify-content: space-between;
  padding: 1.25rem;
  height: 100%;
  min-width: 0;

  ${media.lessThan('small')`
    padding: 1rem;
  `}
`

const Schedule = styled.span`
  font-size: 0.625rem;
  line-height: 1rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: var(--letter-spacing-wide);
  padding: 5px 12px;
  max-width: 100%;
  margin: 0;
  background: var(--color-bg);
  border-radius: var(--border-radius-small);
  color: #9b9b9b;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: uppercase;
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.125rem;
  line-height: 1.5625rem;
  font-weight: var(--font-weight-bold);
  max-width: 100%;
  margin: 0;
  color: var(--color-primary);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.625rem;

  ${media.lessThan('small')`
    font-size: 0.875rem;
    line-height: 1.1875rem;
  `}
`

function ArticleCard(props) {
  const {
    imageUrl = '',
    logoUrl = '',
    schedule = '',
    title = '',
    link = '',
    isDisabled = false,
  } = props

  const truncatedTitle = truncateString(title, 56)

  return (
    <CardWrapper>
      <StyledLink to={link} isDisabled={isDisabled}>
        <StyledCard>
          <CardImageWrapper>
            <CardImageBanner url={imageUrl} />
            <CardImageLogo url={logoUrl} />
          </CardImageWrapper>
          <CardContent>
            <Title>{truncatedTitle}</Title>
            {!!schedule && <Schedule>{schedule}</Schedule>}
          </CardContent>
        </StyledCard>
      </StyledLink>
    </CardWrapper>
  )
}

ArticleCard.defaultProps = {}

ArticleCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  schedule: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default ArticleCard
